module.exports = __webpack_public_path__ + "img/flag-red.38f4bf1c.svg";